import { IAction } from "../../ts/redux";

export function createAction(type: string, payload: object = {}): IAction {
    return {
        type,
        payload
    };
}